(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskFormParameter', {
    bindings: {
      parameter: '<',
      focusInput: '<',
      taskStateDetails: '<',
      taskType: '<',
      onValueChanged: '&'
    },
    controller: UserTaskFormParameterController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-form/user-task-form-parameter/user-task-form-parameter.view.html'
  });

  function UserTaskFormParameterController(
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.handleValueChange = handleValueChange;

    // TODO: how to get values for key type of parameter

    function onInit() {
      vm.parameterValue = vm.parameter.defaultValue;
      handleValueChange();
    }

    function handleValueChange() {
      vm.onValueChanged({
        param: vm.parameter.name,
        value: vm.parameterValue || vm.parameter.defaultValue
      });
    }


  }
})();
